import { Box, CssBaseline, Divider } from "@mui/material";
import type { FC, ReactElement } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router";
import PublicNavbar from "../../components/Navigation/PublicNavbar";
import Footer from "../../components/Footer/Footer";
import PlatformDesc from "./components/PlatformDesc/PlatformDesc";

const LandingPage: FC = (): ReactElement => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CssBaseline />

      <div id="top" />
      <PublicNavbar />

      <Box sx={{ flex: 1 }}>
        <PlatformDesc />

        {/*<LogoCollection />*/}
        {/* <Features /> */}
        {/*<Testimonials />*/}
        {/*<Divider />*/}
        {/*<Highlights />*/}
        {/*<Divider />*/}
        {/*<Pricing />*/}
        {/*<Divider />*/}
        {/* <FAQ /> */}
      </Box>

      <Divider />
      <Footer />
    </Box>
  );
};

export default LandingPage;
